import axios from "axios";

export default axios.create({
  baseURL: "http://localhost:5000/",
  headers: {
    "content-type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
    "ngrok-skip-browser-warning": true,
  },
});
